// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"sS-z","categoryName":"tS-z","categoryNameSearchHeader":"uS-z","categoryContent":"vS-z","bottomAligned":"wS-z","image":"xS-z","imageNoBackground":"yS-z"};